import React from "react";
import { useSelector } from "react-redux";
import { getIsAdmin } from "../../../store/selector/userSelector";
import CustomButton from "../../Buttons/CustomButton";

type AdminButtonProp = {
  title: string;
  link: string;
  isUserSide?: boolean;
};

function AdminButton({ title, link, isUserSide }: Readonly<AdminButtonProp>) {
  const isAdmin = useSelector(getIsAdmin);
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {isAdmin && (
        <a className="d-flex gap-2 align-items-center" href={link}>
          {isUserSide ? (
            <>
              <i className="fa-light fa-arrow-up-right-from-square mr-1" /> {title}
            </>
          ) : (
            <CustomButton variant="blue">{title}</CustomButton>
          )}
        </a>
      )}
    </>
  );
}

export default AdminButton;
